<template>
    <section class="Imprint">
        <preloader v-if="getLoader" :isStatic="true"/>

        <div class="container">
            <BackButton
                    v-if="isLogin"
                    defaultRoute="/members/dashboard"
            />

            <div class="static-pages"  v-html="getStaticPageContent"></div>
        </div>
    </section>
</template>

<script>
    import preloader from '@/elements/Table/TablePreloader'
    import {mapGetters} from 'vuex'
    export default {
        components: {
            preloader
        },
        computed: {
            ...mapGetters([
                'getStaticPageContent',
                'getClient',
                'getLoader'
            ]),

            isLogin() {
                return Object.keys(this.getClient).length !== 0
            }
        },
        async created() {
            await this.$store.dispatch('CLIENT_GET_STATIC_PAGE', {page: 'terms-of-use'})
        }
    }
</script>
